import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import LeaveLogs from "../../components/Leave/LeaveLogs";
import Spinner from "../../components/SpringLoader/index";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { GET, newFetch } from "../../helpers/fetch";

const Leave = () => {
  const { t } = useTranslation();
  const [leaves, setLeaves] = useState([]);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const fetchAll = async () => {
    try {
      let api_path = `/associate-leaves/${
        JSON.parse(localStorage.getItem("user")).id
      }`;
      let response = await newFetch(GET, api_path);

      if (response.success && response.success) {
        let leaves = response.data;
        setLeaves(leaves);
        setLoading(false);
      } else {
        if (response.success) {
          ToastUtil.success(response.message);
        } else {
          ToastUtil.error(response.message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateState = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    fetchAll();
  }, [update]);

  return (
    <div>
      <div className="container pt-4">
        <h4 className="text-brand">
          <Link to="/">
            <i
              className="fas fa-arrow-left link"
              style={{ cursor: "pointer" }}
            />
          </Link>
          &nbsp;&nbsp;{t("Leave Filling")}
        </h4>
        <div className="accordion my-3 bg-white" id="accordionFAQs">
          {loading ? (
            <Spinner />
          ) : (
            <React.Fragment>
              <br />
              <br />
              <div className="edit-button-wrapper mb-4 d-flex justify-content-between align-items-center">
                <button
                  onClick={() => history.push("/leave-apply")}
                  className="btn btn-design btn-brand"
                >
                  {t("Submit Leave")}
                </button>
              </div>

              <div className="d-flex justify-content-end mb-2">
                <button
                  onClick={() => history.push("/leave-entitlement")}
                  className="btn btn-link text-primary"
                  style={{ textDecoration: "none", fontSize: "0.85rem" }}
                >
                  {t("See Leave Entitlement")}
                </button>
              </div>

              <LeaveLogs leaves={leaves} updateState={updateState} />
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default Leave;
